import React from "react";
import { Card, Tooltip, Icon } from "antd";

const iconStyle = {
  float: "left",
  margin: "3px 6px 3px 0"
};

export const StatusBadgeComponent = props => {
  if (props)
    return (
      <Tooltip title={props.status.text}>
        <div
          className="status--badge"
          style={{
            color: props.status.color,
            border: "1px solid " + props.status.color,
            backgroundColor: props.status.color + "15"
          }}
          datacode={props.status.code}
        >
          {props.status.text}
        </div>
      </Tooltip>
    );
  return null;
};



// WEBPACK FOOTER //
// ./src/components/Mobile/StatusBadge/StatusBadgeComponent.js